import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

function StatCard({ title, value, icon }) {
    const theme = useTheme();

    return (
        <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
            <CardContent>
                <Typography component="h2" variant="subtitle2" gutterBottom>
                    {title}
                </Typography>
                <Stack
                    direction="column"
                    sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}
                >
                    <Stack sx={{ justifyContent: 'space-between' }}>
                        <Stack
                            direction="row"
                            sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                        >
                            {value ? (
                                <Typography variant="h4" component="p">
                                    {(() => {
                                        const num = parseInt(value.replace(/[^0-9]/g, ''), 10);
                                        if (num >= 1000) {
                                            return `${(num / 1000).toFixed(1)}k`;
                                        }
                                        if (num > 99) {
                                            return value.toLocaleString();
                                        }
                                        return value;
                                    })()}
                                </Typography>
                            ) : (
                                <Skeleton variant="text" width={120} height={40} sx={{ bgcolor: theme.palette.background.paper }} />
                            )}

                            {React.cloneElement(icon, { sx: { color: theme.palette.mode === 'light' ? '#90CAF9' : '#1976D2' } })}
                        </Stack>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}

StatCard.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    icon: PropTypes.element,
};

export default StatCard;
